import DataApi from './DataApi';

class RecycleBinApi extends DataApi {
  constructor() {
    super('recycle-bin');
  }

  fetchEntries(params = {}, config = {}) {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        qs.set(key, String(value));
      }
    });
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return this.get(suffix, config);
  }

  fetchEntryById(id) {
    return this.get(`/${encodeURIComponent(id)}`);
  }

  restoreEntry(id, options = {}) {
    const qs =
      options.restoreParents === true ? '?restoreParents=true' : '';
    return this.post(`/${encodeURIComponent(id)}/restore${qs}`, {});
  }

  bulkRestoreEntries(ids, options = {}) {
    return this.post('/bulk-restore', { ids, options });
  }

  bulkPermanentDeleteEntries(ids, options = {}) {
    return this.post('/bulk-permanent-delete', { ids, options });
  }

  permanentDeleteEntry(id) {
    return this.delete(`/${encodeURIComponent(id)}`);
  }
}

export default RecycleBinApi;
